import React from 'react';
/* eslint-disable */
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Checkbox } from 'antd';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
function Consent() {
    // eslint-disable-next-line
    const [scroll, setScroll] = React.useState('body');
    const [open, setOpen] = React.useState(false);
    const [checked, setChecked] = useState(false);
    const naivgate = useNavigate();
    const handleCheck = (e) => {
        setChecked(e.target.checked);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleCancel = () => {
        naivgate('/merchant-home');
    };
    useEffect(() => {
        setOpen(true);
    }, []);
    const descriptionElementRef = React.useRef(null);
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    const pdf = 'https://aceware-commons-public.s3.ap-south-1.amazonaws.com/public_files/image_66b5b21ce9e11.pdf';
    return (
        <Dialog
            open={open}
            scroll={scroll}
            onClose={handleClose}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogContent dividers={scroll === 'body'}>
                <iframe src={pdf} width="100%" title="PDF Viewer" height="600px">
                    This browser does not support iframes.
                </iframe>
                {/* <span style={{ color: 'red' }}>Please accept the terms and conditions</span> */}
                {/* <div className="modal-footer">
                    <Checkbox checked={checked} onChange={handleCheck}>
                        I accept the terms and conditions
                    </Checkbox>
                    <Button onClick={handleClose} type="primary">
                        Agree
                    </Button>
                    <Button onClick={handleCancel} type="primary">
                        Cancel
                    </Button>
                </div> */}
            </DialogContent>
        </Dialog>
    );
}

export default Consent;
